import moment from 'moment';

export const getDocTitle = (doc) => {
  return `${doc.docNumber} от ${moment(doc.docDate).format('DD.MM.YYYY')}`;
};
